import { Injectable } from '@angular/core';
import { NgxRolesService, NgxPermissionsService } from 'ngx-permissions';

export enum USER_ROLE {
  Doctor = 'doctor',
  FrontOfficeUser = 'front-office-user',
  SystemAdmin = 'system-admin',
  Receptionist = 'receptionist',
  PracticingNurse = 'practicing-nurse',
  TriageNurse = 'triage-nurse',
  VitalsOnlyUser = 'vitals-only-user',
}

export enum CONSULT_PERMISSION {
  All = '**',
  Capture = 'canCaptureConsult',
  Complete = 'canCompleteConsult',
  Cancel = 'canCancelConsult',
  Save = 'canSaveConsult',
}

export enum FRONT_DESK_PERMISSION {
  DenyViewPatientFile = 'denyViewPatientfile',
  DenyViewConditionTracker = 'denyViewConditionTracker',
  DenyViewPathology = 'denyViewPathology',
  DenyViewSettings = 'denyViewSettings',
}

export enum RECEPTIONIST_PERMISSION {
  DenyViewReports = 'denyViewReports',
  DenyViewStylusTemplates = 'denyViewStylusTemplates',
  DenyViewProviderEdit = 'denyViewProviderEdit',
}

export enum VITALS_ONLY_PERMISSION {
  DenyViewExecutiveSummary = 'denyViewExecutiveSummary',
  DenyViewPatientData = 'denyViewPatientData',
  DenyViewTasks = 'denyViewTasks',
  DenyViewAddPatient = 'denyViewAddPatient',
  DenyViewLetters = 'denyViewLetters',
  DenyViewAddressBook = 'denyViewAddressBook',
  DenyViewClinicalAssistant = 'denyViewClinicalAssistant',
}

@Injectable({
  providedIn: 'root',
})
export class RoleManagerService {
  constructor(
    private permissionsService: NgxPermissionsService,
    private rolesService: NgxRolesService
  ) {}

  public setRoleAndPermissions(role: USER_ROLE) {
    let permissions: string[] = [];

    switch (role) {
      case USER_ROLE.Doctor:
        permissions = this.ToArray(CONSULT_PERMISSION);

        break;
      case USER_ROLE.PracticingNurse:
        permissions = this.ToArray(CONSULT_PERMISSION);

        break;
      case USER_ROLE.TriageNurse:
        permissions = this.ToArray(CONSULT_PERMISSION).filter(f => f === CONSULT_PERMISSION.All || f === CONSULT_PERMISSION.Save);

        break;
      case USER_ROLE.SystemAdmin:
        permissions = ['*', ...this.ToArray(CONSULT_PERMISSION)];

        break;
      case USER_ROLE.FrontOfficeUser:
        permissions = this.ToArray(FRONT_DESK_PERMISSION);

        break;
      case USER_ROLE.Receptionist:
        permissions = [...this.ToArray(FRONT_DESK_PERMISSION), ...this.ToArray(RECEPTIONIST_PERMISSION)];

        break;

      case USER_ROLE.VitalsOnlyUser:
        permissions = [
          ...this.ToArray(FRONT_DESK_PERMISSION).filter(f => f !== FRONT_DESK_PERMISSION.DenyViewPatientFile),
          ...this.ToArray(RECEPTIONIST_PERMISSION),
          ...this.ToArray(VITALS_ONLY_PERMISSION),
        ];

        break;
    }

    this.rolesService.addRole(role, permissions);
    this.permissionsService.addPermission(permissions);
  }

  public flushRolesAndPermissions() {
    this.permissionsService.flushPermissions();
    this.rolesService.flushRoles();
  }

  private ToArray(enumme) {
    return Object.keys(enumme).map(key => enumme[key]);
  }
}
